
import { defineComponent, reactive, onBeforeMount } from 'vue';
import { TButton } from '@tencent/web-vbui';
import { i18n, reportStatistics } from '@tencent/vb-web-base';
import { getQuery } from '@tencent/multi-url';
import { to } from '@tencent/vb-web-base-core';
import { baseMixins } from '@common/mixins/baseMixins';
import ClipboardJS from 'clipboard';
import { toast } from '@tencent/web-vbui/dist/components/t-toast/toast';
import { spin } from '@tencent/web-vbui/src/components/t-spin/spin';
import Contract from '@tencent/vb-web-contract';
import { GetLoanConfigList } from '../../core/network/NodeAPI';
import { IInviteCodeM2Config } from '../../core/interface/IModel';
export default defineComponent({
  components: {
    TButton,
  },
  setup() {
    const { getT, getLang } = i18n;
    const $t = getT();
    const lang = getLang();
    const { setTitle, isEng, showModalError } = baseMixins();
    setTitle($t('贷款优惠活动'));
    const { inviteCode, id } = getQuery();

    // 活动页面配置
    const configInfo = reactive<IInviteCodeM2Config>({
      contractKey: '',
      'banner-m2': '',
      'inviteCodePic-m2': '',
      'inviteCodeinfo-m2': '',
      'inviteCodeContract-m2': '',
      'guide-m2': '',
      'remark-m2': '',
    });

    const formatParam = (data: string): string => {
      try {
        const arr = JSON.parse(data);
        return arr[0][lang];
      } catch (err) {
        return '';
      }
    };

    // 获取页面配置
    const getConfigInfo = async () => {
      const [data, err] = await to(GetLoanConfigList<{ content: IInviteCodeM2Config[] }>('mgm_act_page'));
      if (err) {
        showModalError(err.message, err.code);
        return;
      }
      if (data?.content?.length) {
        const config = data.content.find(item => item?.id === id);
        if (config) {
          configInfo.contractKey = config.contractKey;
          configInfo['banner-m2'] = formatParam(config['banner-m2']);
          configInfo['inviteCodePic-m2'] = formatParam(config['inviteCodePic-m2']);
          configInfo['inviteCodeinfo-m2'] = formatParam(config['inviteCodeinfo-m2']);
          configInfo['inviteCodeContract-m2'] = formatParam(config['inviteCodeContract-m2']);
          configInfo['guide-m2'] = formatParam(config['guide-m2']);
          configInfo['remark-m2'] = formatParam(config['remark-m2']);
        }
      }
    };

    onBeforeMount(async () => {
      spin.show();
      await getConfigInfo();
      spin.hide();
    });

    const handleClick = () => {
      const clipboard = new ClipboardJS('.activity-copy');
      reportStatistics({
        evtName: 'copyCode',
        desc: '复制邀请码',
      });
      clipboard.on('success', () => {
        toast.show({
          title: $t('复制成功'),
        });
        clipboard.destroy();
      });
      clipboard.on('error', (err) => {
        console.log(err);
        toast.show({
          title: $t('复制失败'),
        });
        clipboard.destroy();
      });
    };

    // 查看协议
    const checkProto = () => {
      const contract = new Contract({
        key: configInfo.contractKey,
        needLogin: false,
        autoSign: false,
        containerType: 'dialog',
        needAgree: false,
        needCheckBox: false,
        hideBtn: true,
        needTitle: false,
      });
      contract.preview();
    };
    return {
      configInfo,
      lang,
      isEng,
      inviteCode,
      handleClick,
      checkProto,
    };
  },
});
